export default "__VITE_ASSET__Cwx50H_s__"